import { useEffect, useState, useRef, useDeferredValue } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { config, encodeBase64RequestBody, priceFormat, shortenUrl } from "./Components/Config";
import { format } from "date-fns";

const SalesOrderAdd = () => {
  const { id_quotation } = useParams();
  const [ quotation, setQuotation ] = useState(null);
  const [ quotationItems, setQuotationItems ] = useState(null);
  const [ quotationItemList, setQuotationItemList ] = useState(null);
  const [ quotationRemarks, setQuotationRemarks ] = useState('');
  const [ salesOrderRemarks, setSalesOrderRemarks ] = useState('');
  const [ paymentSimulations, setPaymentSimulations ] = useState(null);
  const [ iouList, setIouList ] = useState(null);
  const [ attainmentItems, setAttainmentItems ] = useState([]);
  const [ attainmentQuarter, setAttainmentQuarter ] = useState(format(new Date(), 'Q'));
  const [ attainmentRemarks, setAttainmentRemarks ] = useState('');
  const [ subcompany, setSubcompany ] = useState(null);
  const [ attachmentList, setAttachmentList ] = useState([]);
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);
  
  const navigate = useNavigate();
  
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    if (id_quotation) {
      getQuotation();
      getPaymentSimulations();
    }
  }, [id_quotation]);

  useEffect(() => {
    if (quotation) {
      getSubcompany();
    }
  }, [quotation]);

  const getQuotation = async () => {
    try {
      const fetchGetQuotation = await jwtFetch(config.ENDPOINT + 'get/quotation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_quotation: id_quotation
        })
      });
      const responseGetQuotation = await fetchGetQuotation.json();
      if (responseGetQuotation.status === 200) {
        setQuotation(responseGetQuotation.data[0]);
        setQuotationRemarks(responseGetQuotation.data[0].quotation_remarks);
        let items = [];
        let itemList = [];
        let itemAttachments = [];
        for (let i in responseGetQuotation.data[0].quotation_items) {
          responseGetQuotation.data[0].quotation_items[i].companies = [{
            id_quotation_item: responseGetQuotation.data[0].quotation_items[i].quotation_item_id,
            company_id: responseGetQuotation.data[0].subcompany_id ? responseGetQuotation.data[0].subcompany_id : '',
            company_name: responseGetQuotation.data[0].subcompany_id ? responseGetQuotation.data[0].subcompany_name : '',
            product_qty: responseGetQuotation.data[0].quotation_items[i].product_qty,
            product_cost_original: responseGetQuotation.data[0].quotation_items[i].product_cost_original,
            product_cost: responseGetQuotation.data[0].quotation_items[i].product_cost,
            product_price_original: responseGetQuotation.data[0].quotation_items[i].product_price_original,
            product_price: responseGetQuotation.data[0].quotation_items[i].product_price,
            product_subtotal: responseGetQuotation.data[0].quotation_items[i].product_subtotal,
            product_discount_price: responseGetQuotation.data[0].quotation_items[i].product_discount_price,
            product_discount_rate: responseGetQuotation.data[0].quotation_items[i].product_discount_rate,
            product_discount_prorate: responseGetQuotation.data[0].quotation_items[i].product_discount_prorate,
            product_margin_price: responseGetQuotation.data[0].quotation_items[i].product_margin_price,
            product_margin_rate: responseGetQuotation.data[0].quotation_items[i].product_margin_rate,
            product_total: responseGetQuotation.data[0].quotation_items[i].product_total,
            product_grand_total: responseGetQuotation.data[0].quotation_items[i].product_grand_total,
            product_prorate: 100,
            contract_long_period: responseGetQuotation.data[0].quotation_items[i].contract_long_period,
          }];
          items.push(responseGetQuotation.data[0].quotation_items[i]);
          setQuotationItems([...items]);
        }
        for (let i in responseGetQuotation.data[0].quotation_item_list) {
          itemList.push(responseGetQuotation.data[0].quotation_item_list[i]);
          setQuotationItemList([...itemList]);
        }

        if (JSON.parse(responseGetQuotation.data[0].attachment_files).length > 0) {
          itemAttachments = JSON.parse(responseGetQuotation.data[0].attachment_files);
        }
        itemAttachments.push({
          name: 'Signed Quotation',
          files: '',
          loading: false
        });
        setAttachmentList([...attachmentList, ...itemAttachments]);
      } else {
        alert(responseGetQuotation.message);
      }
    } catch (error) {
      console.error('Error in getQuotation:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getPaymentSimulations = async () => {
    try {
      const fetchPaymentSimulations = await jwtFetch(config.ENDPOINT + 'get/quotation_payment_simulation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          quotation_id: id_quotation
        })
      });
      const responsePaymentSimulations = await fetchPaymentSimulations.json();
      if (responsePaymentSimulations.status === 200) {
        setPaymentSimulations(responsePaymentSimulations.data);
      } else {
        alert(responsePaymentSimulations.message);
      }
    } catch (error) {
      console.error('Error in getPaymentSimulations:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };
    
  const getSubcompany = async () => {
    try {
      const requestGetSubcompany = {
        "id_subcompany": quotation.subcompany_id
      }
      const fetchGetSubcompany = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encodeBase64RequestBody(requestGetSubcompany)
      });
      const responseGetSubcompany = await fetchGetSubcompany.json();
      if (responseGetSubcompany.status === 200) {
        setSubcompany(responseGetSubcompany.data[0]);
        if (responseGetSubcompany.data[0].company_npwp_files) {
          const attachment = {
            name: 'NPWP',
            files: JSON.parse(responseGetSubcompany.data[0].company_npwp_files),
            loading: false
          };
          setAttachmentList([...attachmentList, attachment]);        
        }
      } else {
        alert(responseGetSubcompany.message);
      }
    } catch (error) {
      console.error('Error in getSubcompany:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const addAttachments = () => {
    const attachment = {
      name: '',
      files: '',
      loading: false
    };
    setAttachmentList([...attachmentList, attachment]);
  }

  const changeAttachmentData = (column, value, index) => {
    const attachment = attachmentList[index];
    attachment[column] = value;
    if (column === 'files') {
      attachment.loading = false;
    }
    setAttachmentList([...attachmentList]);
  }

  const uploadAttachments = async (files, index) => {
    changeAttachmentData('loading', true, index);
    try {      
      const encodedFiles = await Promise.all(
        files.map((file, fileIndex) => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            const result = reader.result || '';
            const base64Content = String(result).includes(',')
              ? String(result).split(',')[1]
              : String(result);
            resolve({
              index: fileIndex,
              name: file.name,
              type: file.type || 'application/octet-stream',
              buffer_base64: base64Content,
            });
          };
          reader.onerror = () => reject(new Error('Failed to read attachment file.'));
          reader.readAsDataURL(file);
        }))
      );

      const responseUploadAttachments = await jwtFetch(config.ENDPOINT + 'upload/google-drive', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody({
          files: encodedFiles,
        }),
      });
      if (!responseUploadAttachments.ok) {
        throw new Error(`Upload failed with status: ${responseUploadAttachments.status}`);
      }
      const resultUploadAttachments = await responseUploadAttachments.json();
      if (resultUploadAttachments.status === 200) {
        changeAttachmentData('files', resultUploadAttachments.data, index);
      } else {
        alert(`Upload error: ${resultUploadAttachments.message}`);
      }
    } catch (error) {
      alert(`Upload error: ${error.message || error}`);
    } finally {
      changeAttachmentData('loading', false, index);
    }
  }

  const removeAttachments = (index) => {
    attachmentList.splice(index, 1);
    setAttachmentList([...attachmentList]);
  }

  const addAttainmentItem = () => {
    const attainmentItem = {
      quoation_item_list_id: '',
      product_id: '',
      product_display_name: '',
      product_qty: 0,
      product_qty_max: 0,
      product_period: 0,
      product_period_max: 0,
      product_cost: 0,
      product_price: 0,
      product_discount_price: 0,
      product_discount_unit: 0,
      product_subtotal: 0,
      product_total: 0,
      product_total_cost: 0,
      product_margin_price: 0,
      product_margin_rate: 0,
    };
    setAttainmentItems([...attainmentItems, attainmentItem]);
  }

  const changeAttainmentItem = (column, value, index) => {
    const attainmentItem = attainmentItems[index];
    attainmentItem[column] = value;
    if (column === 'id_quotation_item_list') {
      const quotationItem = quotationItemList?.find(item => item.id_quotation_item_list === Number(value));
      attainmentItem.quotation_item_list_id = value;
      attainmentItem.product_id = quotationItem.product_id;
      attainmentItem.product_display_name = quotationItem.product_display_name;
      attainmentItem.product_price = Number(quotationItem.product_price) || 0;
      attainmentItem.product_cost = Number(quotationItem.product_cost) || 0;
      attainmentItem.product_qty = Number(quotationItem.product_qty) || 0;
      attainmentItem.product_qty_max = Number(quotationItem.product_qty) || 0;
      attainmentItem.product_period = Number(quotationItem.contract_long_period) || 0;
      attainmentItem.product_period_max = Number(quotationItem.contract_long_period) || 0;
      attainmentItem.product_discount_price = Number(quotationItem.product_discount_price) || 0;
      attainmentItem.product_discount_unit = Number(quotationItem.product_discount_price / (Number(quotationItem.product_qty) * Number(quotationItem.contract_long_period)));
    } else if (column === 'product_qty') {
      attainmentItem.product_qty = Number(value) || 0;
      if (attainmentItem.product_qty > attainmentItem.product_qty_max) {
        attainmentItem.product_qty = attainmentItem.product_qty_max;
      }
    } else if (column === 'product_period') {
      attainmentItem.product_period = Number(value) || 0;
      if (attainmentItem.product_period > attainmentItem.product_period_max) {
        attainmentItem.product_period = attainmentItem.product_period_max;
      }
    }
    attainmentItem.product_subtotal = attainmentItem.product_price * (attainmentItem.product_qty * attainmentItem.product_period);
    attainmentItem.product_discount_item = attainmentItem.product_discount_unit * (attainmentItem.product_qty * attainmentItem.product_period);
    attainmentItem.product_total = attainmentItem.product_subtotal - attainmentItem.product_discount_item;
    attainmentItem.product_total_cost = attainmentItem.product_cost * (attainmentItem.product_qty * attainmentItem.product_period);
    attainmentItem.product_margin_price = attainmentItem.product_total - attainmentItem.product_total_cost;
    attainmentItem.product_margin_rate = attainmentItem.product_margin_price / attainmentItem.product_total * 100;
    setAttainmentItems([...attainmentItems]);
  }

  const removeAttainmentItem = (index) => {
    attainmentItems.splice(index, 1);
    setAttainmentItems([...attainmentItems]);
  }

  const copyItem = (itemIndex) => {
    let description = quotationItems[itemIndex].product_display_name;
    description += '\n\n';
    description += quotationItems[itemIndex].product_display_description;
    description += '\n\n';
    if (iouList) {
      description += iouList[0].service_type === 'Additional' ? 'Period - Current Active Subscription: '+ (format(new Date(iouList[0].iou_items[itemIndex].licence_start_period), 'd MMMM yyyy') + " - " + format(new Date(iouList[0].iou_items[itemIndex].licence_end_period), 'd MMMM yyyy')) + '\n' : '';
      description += 'Period - for this QT Order: '+ (format(new Date(iouList[0].iou_items[itemIndex].start_term_period), 'd MMMM yyyy') + " - " + format(new Date(iouList[0].iou_items[itemIndex].end_term_period), 'd MMMM yyyy')) + '\n';
    }
    navigator.clipboard.writeText(description);
  }

  const submitSalesOrderAdd = async () => {
    try {
      setIsLoadingSubmit(true);

      if (attachmentList.length === 0 || attachmentList[0].files === '') {
        alert('Please upload at least 1 attachment file.');
        setIsLoadingSubmit(false);
        return;
      }

      if (attachmentList) {
        const fetchEditQuotation = await jwtFetch(config.ENDPOINT + 'update/quotation_attachment', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id_quotation: id_quotation,
            attachment_files: JSON.stringify(attachmentList)
          })
        });
        await fetchEditQuotation.json();
      }

      if (quotationRemarks !== quotation.quotation_remarks) {
        const fetchEditQuotation = await jwtFetch(config.ENDPOINT + 'update/quotation', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id_quotation: id_quotation,
            quotation_remarks: quotationRemarks
          })
        });
        await fetchEditQuotation.json();
      }

      const quotationItemAccounts = [];
      const soItems = [];
      const soItemList = [];
      for (let i in quotationItems) {
        soItems.push({
          "id_quotation_item": quotationItems[i].id_quotation_item,
          "product_id": quotationItems[i].product_id,
          "product_display_name": quotationItems[i].product_display_name,
          "product_display_description": quotationItems[i].product_display_description,
          "product_type": quotationItems[i].product_type,
          "product_domain": quotationItems[i].product_domain,
          "product_qty": quotationItems[i].product_qty,
          "product_currency_original": quotationItems[i].product_currency_original,
          "product_currency": quotationItems[i].product_currency,
          "product_cost_original": quotationItems[i].product_cost_original,
          "product_cost": quotationItems[i].product_cost,
          "product_price_original": quotationItems[i].product_price_original,
          "product_price": quotationItems[i].product_price,
          "product_margin_rate": quotationItems[i].product_margin_rate,
          "product_margin_price": quotationItems[i].product_margin_price,
          "product_subtotal": quotationItems[i].product_subtotal,
          "product_discount_rate": quotationItems[i].product_discount_rate,
          "product_discount_price": quotationItems[i].product_discount_price,
          "product_discount_prorate": quotationItems[i].product_discount_prorate,
          "product_total": quotationItems[i].product_total,
          "product_grand_total": quotationItems[i].product_grand_total,
          "product_active_licence_date": null,
          "service_type": quotationItems[i].service_type,
          "contract_long_period": quotationItems[i].contract_long_period,
          "contract_duration_period": quotationItems[i].contract_duration_period,
          "billing_long_period": quotationItems[i].billing_long_period,
          "billing_duration_period": quotationItems[i].billing_duration_period,
          "billing_payment_term": quotationItems[i].billing_payment_term,
          "billing_payment_period": quotationItems[i].billing_payment_period,
          "status": "In Progress",
        });
        for (let c in quotationItems[i].companies) {
          quotationItemAccounts.push({
            "quotation_id": id_quotation,
            "quotation_item_id": quotationItems[i].id_quotation_item,
            "company_id": quotation.company_id,
            "subcompany_id": quotationItems[i].companies[c].company_id,
            "product_id": quotationItems[i].product_id,
            "product_display_name": quotationItems[i].product_display_name,
            "product_display_description": quotationItems[i].product_display_description,
            "product_type": quotationItems[i].product_type,
            "product_domain": quotationItems[i].product_domain,
            "product_qty": quotationItems[i].companies[c].product_qty,
            "product_currency_original": quotationItems[i].product_currency_original,
            "product_currency": quotationItems[i].product_currency,
            "product_cost_original": quotationItems[i].companies[c].product_cost_original,
            "product_cost": quotationItems[i].companies[c].product_cost,
            "product_price_original": quotationItems[i].companies[c].product_price_original,
            "product_price": quotationItems[i].companies[c].product_price,
            "product_margin_rate": quotationItems[i].companies[c].product_margin_rate,
            "product_margin_price": quotationItems[i].companies[c].product_margin_price,
            "product_subtotal": quotationItems[i].companies[c].product_subtotal,
            "product_discount_rate": quotationItems[i].companies[c].product_discount_rate,
            "product_discount_price": quotationItems[i].companies[c].product_discount_price,
            "product_discount_prorate": quotationItems[i].companies[c].product_discount_prorate,
            "product_total": quotationItems[i].companies[c].product_total,
            "product_grand_total": quotationItems[i].companies[c].product_grand_total,
            "product_prorate": quotationItems[i].companies[c].product_prorate,
            "service_type": quotationItems[i].service_type,
            "contract_long_period": quotationItems[i].contract_long_period,
            "contract_duration_period": quotationItems[i].contract_duration_period,
            "billing_long_period": quotationItems[i].billing_long_period,
            "billing_duration_period": quotationItems[i].billing_duration_period,
            "billing_payment_term": quotationItems[i].billing_payment_term,
            "billing_payment_period": quotationItems[i].billing_payment_period
          });
        };
      }
      for (let i in quotationItemList) {
        soItemList.push({
          "id_quotation_item_list": quotationItemList[i].id_quotation_item_list,
          "quotation_item_id": quotationItemList[i].quotation_item_id,
          "product_id": quotationItemList[i].product_id,
          "product_display_name": quotationItemList[i].product_display_name,
          "product_display_description": quotationItemList[i].product_display_description,
          "product_type": quotationItemList[i].product_type,
          "product_domain": quotationItemList[i].product_domain,
          "product_qty": quotationItemList[i].product_qty,
          "product_currency_original": quotationItemList[i].product_currency_original,
          "product_currency": quotationItemList[i].product_currency,
          "product_cost_original": quotationItemList[i].product_cost_original,
          "product_cost": quotationItemList[i].product_cost,
          "product_price_original": quotationItemList[i].product_price_original,
          "product_price": quotationItemList[i].product_price,
          "product_margin_rate": quotationItemList[i].product_margin_rate,
          "product_margin_price": quotationItemList[i].product_margin_price,
          "product_subtotal": quotationItemList[i].product_subtotal,
          "product_discount_rate": quotationItemList[i].product_discount_rate,
          "product_discount_price": quotationItemList[i].product_discount_price,
          "product_discount_prorate": quotationItemList[i].product_discount_prorate,
          "product_total": quotationItemList[i].product_total,
          "product_grand_total": quotationItemList[i].product_grand_total,
          "product_active_licence_date": null,
          "service_type": quotationItemList[i].service_type,
          "contract_long_period": quotationItemList[i].contract_long_period,
          "contract_duration_period": quotationItemList[i].contract_duration_period,
          "billing_long_period": quotationItemList[i].billing_long_period,
          "billing_duration_period": quotationItemList[i].billing_duration_period,
          "billing_payment_term": quotationItemList[i].billing_payment_term,
          "billing_payment_period": quotationItemList[i].billing_payment_period,
          "status": "In Progress",
        });
      }
      const requestQuotationBillingAdd = {
        "quotation_id": id_quotation,
        "quotation_item_accounts": quotationItemAccounts,
        "action": 'Setting Billing Account',
        "updated_by": crmUser.user_keyid,
        "updated_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        "so": {
          "quotation_id": id_quotation,
          "company_id": quotation.company_id,
          "company_name": quotation.company_name,
          "subcompany_id": quotation.subcompany_id,
          "subcompany_name": quotation.subcompany_name,
          "so_currency": quotation.quotation_currency,
          "so_exchange_rate": quotation.quotation_exchange_rate,
          "so_expired_date": format(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), 'yyyy-MM-dd'),
          "so_billing_date": format(new Date(), 'yyyy-MM-dd'),
          "so_subtotal": quotation.quotation_subtotal,
          "so_discount_rate": quotation.quotation_discount_rate,
          "so_discount_price": quotation.quotation_discount_price,
          "so_cost": quotation.quotation_cost,
          "so_margin_rate": quotation.quotation_margin_rate,
          "so_margin_price": quotation.quotation_margin_price,
          "so_total": quotation.quotation_total,
          "so_remarks": salesOrderRemarks,
          "so_approval": 'Draft',
          "so_status": 'In Progress',
          "so_link": 'In Progress',
          "created_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          "created_by": crmUser.user_keyid,
          "sales_name": quotation.sales_name,
        },
        "so_items": soItems,
        "so_item_list": soItemList,
      };

      if (attainmentItems.length > 0) {
        const requestAttainmentAdd = {
          "quotation_id": id_quotation,
          "attainment_items": attainmentItems,
          "attainment_quarter": attainmentQuarter,
          "attainment_remarks": attainmentRemarks,
          "created_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          "created_by": crmUser.user_keyid,
        }

        const fetchAttainmentAdd = await jwtFetch(config.ENDPOINT + 'create/attainment', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestAttainmentAdd)
        });
        await fetchAttainmentAdd.json();
      }

      const fetchQuotationBillingAdd = await jwtFetch(config.ENDPOINT + 'setting/billing_account', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestQuotationBillingAdd)
      });

      const responseQuotationBillingAdd = await fetchQuotationBillingAdd.json();
      if (responseQuotationBillingAdd.status === 200) {      
        window.location.href = '/quotation/detail/' + id_quotation;
      } else {
        alert(responseQuotationBillingAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitSalesOrderAdd:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="salesorder-add">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="salesorder"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">
              
                {quotation && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Sales Order Add</div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Company Group</div>
                          <div className="col-md-8">{quotation.company_name} <a href={`/client/detail/${quotation.company_id}`}><i className="bi bi-link-45deg"/></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Subsidiary</div>
                          <div className="col-md-8">{quotation.subcompany_name} <a href={`/client/subsidiary/detail/${quotation.subcompany_id}`}><i className="bi bi-link-45deg"/></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Currency</div>
                          <div className="col-md-8">{quotation.quotation_currency}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Exchange Rate</div>
                          <div className="col-md-8">1 USD <i className="bi bi-arrow-right mx-1"/> {priceFormat(quotation.quotation_exchange_rate, quotation.quotation_currency)} ({quotation && quotation.quotation_exchange_floating})</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Created Date</div>
                          <div className="col-md-8">{format(quotation.created_on, 'd MMMM yyyy')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Order Type</div>
                          <div className="col-md-8">{quotation.quotation_item_list[0].service_type}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Sales Name</div>
                          <div className="col-md-8">{quotation.sales_name}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card mb-2">
                          <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between">
                              <p className="fs-14 mb-0"><strong>Quotation</strong></p>
                              <a href={"/quotation/detail/" + quotation.id_quotation}>{quotation.quotation_code} <i className="bi bi-link-45deg ms-1"/></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {quotation && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="fs-24">SKU List</div>
                    </div>
                    <div className="bg-white border-radius-4 p-4">
                      <div className="table-responsive">
                        <table className="table table-hover bordered mb-0">
                          <thead>
                            <tr>
                              <th className="bg-gold w-30">#</th>
                              <th className="bg-gold">SKUs</th>
                              <th className="bg-gold w-85">Period</th>
                              <th className="bg-gold w-85">Qty</th>
                              <th className="bg-gold w-105">Cost Price / Unit</th>
                              <th className="bg-gold w-105">Sell Price / Unit</th>
                              <th className="bg-gold w-105">Discount</th>
                              <th className="bg-gold w-125">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {quotation.quotation_item_list && quotation.quotation_item_list.map((item, i) => {
                              const iouItem = iouList?.[0]?.iou_items?.find(iouItem => iouItem.product_id === quotation.quotation_item_list[i].product_id);
                              return (
                                <tr className={item.product_total === 0 ? 'd-none' : ''} key={i}>
                                  <td valign="middle" align="center">{i + 1}</td>
                                  <td valign="middle">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                      <p className="mb-0"><strong>{item.product_display_name}</strong></p>
                                      <button className="btn btn-sm btn-outline-secondary" onClick={() => copyItem(i)}><i className="bi bi-copy"/></button>
                                    </div>
                                    {item.product_display_description && item.product_display_description.split('\n').map((description, d) => (
                                      <div className="row mb-1" key={"description-" + d}>
                                        {description.split(':').length > 1 ? (
                                          <div className="col-4">{description.split(':')[0].trim()}</div>
                                        ) : (
                                          <div className="col-12">{description.trim()}</div>
                                        )}
                                        {description.split(':').length > 1 && (
                                          <div className="col-8">
                                            <div className="d-flex">
                                              <span className="me-2">:</span>
                                              <div>{description.split(':').slice(1).join(':').trim()}</div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                    {iouItem && iouItem.product_type === 'Subscription' && (
                                      <div className="text-secondary">
                                        <hr/>
                                        {iouItem.service_type === 'Additional' && (
                                          <div className="row mb-1">
                                            <div className="col-4">Period - Current Active Subscription</div>
                                            <div className="col-8">
                                              <div className="d-flex">
                                                <span className="me-2">:</span>
                                                <div>{iouItem.licence_start_period ? (format(new Date(iouItem.licence_start_period), 'd MMMM yyyy') + " - " + format(new Date(iouItem.licence_end_period), 'd MMMM yyyy')) : ''}</div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        <div className="row mb-1">
                                          <div className="col-4">Period - for this QT Order</div>
                                          <div className="col-8">
                                            <div className="d-flex">
                                              <span className="me-2">:</span>
                                              <div>{format(new Date(iouItem.start_term_period), 'd MMMM yyyy') + " - " + format(new Date(iouItem.end_term_period), 'd MMMM yyyy')}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                  <td valign="middle" align="center">
                                    {
                                      item.product_type === 'Subscription' ? (
                                        (item.contract_long_period + " " + (item.contract_long_period > 1 ? ' Months' : ' Month'))
                                      ) : 'N/A'
                                    }
                                  </td>
                                  <td valign="middle" align="center">{item.product_qty + ' Unit(s)'}</td>
                                  <td valign="middle" align="center">
                                    <div className="d-flex flex-column justify-content-between py-3">
                                      <span>{priceFormat(item.product_cost, item.product_currency)}</span>
                                      {item.product_currency !== item.product_currency_original && (<hr className="my-3"/>)}
                                      {item.product_currency !== item.product_currency_original && (<span className="text-secondary">{priceFormat(item.product_cost_original, item.product_currency_original)}</span>)}
                                    </div>
                                  </td>
                                  <td valign="middle" align="center">
                                    <div className="d-flex flex-column justify-content-between py-3">
                                      <span>{priceFormat(item.product_price, item.product_currency)}</span>
                                      {item.product_currency !== item.product_currency_original && (<hr className="my-3"/>)}
                                      {item.product_currency !== item.product_currency_original && (<span className="text-secondary">{priceFormat(item.product_price_original, item.product_currency_original)}</span>)}
                                    </div>
                                  </td>
                                  <td valign="middle" align="center">
                                    {item.product_discount_price > 0 ? (
                                      <div className="d-flex flex-column justify-content-between py-3">
                                        <span className="text-danger">-{priceFormat(item.product_discount_price, item.product_currency)}</span>
                                        {item.product_discount_price > 0 && (<hr className="my-3"/>)}
                                        {item.product_discount_price > 0 && (<span className="text-secondary">{priceFormat(item.product_discount_rate, "%")}</span>)}
                                      </div>
                                    ) : 'N/A'}
                                  </td>
                                  <td valign="middle" align="end">
                                    <span>{priceFormat(item.product_total, item.product_currency)}</span>
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td className="text-end" colSpan={7}>
                                Subtotal
                                <br/>
                                Discount on QT {quotation.quotation_discount_price > 0 ? (" (" + priceFormat(quotation.quotation_discount_rate) + "%)") : ""}
                                <br/>
                                Total Before Tax
                              </td>
                              <td className="text-end">
                                {priceFormat(quotation.quotation_subtotal, quotation.quotation_currency)}
                                <br/>
                                <span className="text-danger">{quotation.quotation_discount_price > 0 ? ("-" + priceFormat(quotation.quotation_discount_price, quotation.quotation_currency)) : "0"}</span>
                                <br/>
                                <strong>{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</strong>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                {quotation && paymentSimulations && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="fs-24">Payment Schedules</div>
                    </div>
                    <div className="bg-white border-radius-4 p-4">
                      <div className="table-responsive">
                        <table className="table table-hover bordered mb-0">
                          <thead>
                            <tr>
                              <th className="bg-gold w-90">Schedule</th>
                              <th className="bg-gold w-200">Date</th>
                              <th className="bg-gold">SKUs</th>
                              <th className="bg-gold w-125">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {quotation.quotation_items && (
                              (() => {
                                const termGroups = {};
                                quotation.quotation_items.forEach((item) => {
                                  item.payment_simulations.forEach((payment) => {
                                    const key = `${payment.term_number}-${payment.number_of_months}`;
                                    if (!termGroups[key]) {
                                      termGroups[key] = {
                                        term_number: payment.term_number,
                                        number_of_months: payment.number_of_months,
                                        start_term_period: payment.start_term_period,
                                        end_term_period: payment.end_term_period,
                                        items: [],
                                      };
                                    }
                                    termGroups[key].items.push({
                                      product_display_name: item.product_display_name,
                                      payment_amount_exc_tax: payment.payment_amount_exc_tax,
                                    });
                                  });
                                });
                                const sortedTerms = Object.values(termGroups).sort((a, b) => a.term_number - b.term_number);        
                                return sortedTerms.map((term, termIndex) => {
                                  const rowspan = term.items.length;
                                  return term.items.map((item, itemIndex) => (
                                    <tr key={`term-${termIndex}-item-${itemIndex}`}>
                                      {itemIndex === 0 && (
                                        <>
                                          <td rowSpan={rowspan} valign="middle" align="center">
                                            {term.term_number.replace('Term', 'Schedule')}
                                          </td>
                                          <td rowSpan={rowspan} valign="middle" align="center">
                                            <span>
                                              {(format(new Date(term.start_term_period), 'd MMM yyyy')) + " - " + (format(new Date(term.end_term_period), 'd MMM yyyy'))}
                                            </span>
                                          </td>
                                        </>
                                      )}
                                      <td>{item.product_display_name}</td>
                                      <td style={{ textAlign: 'right' }}>
                                        {priceFormat(item.payment_amount_exc_tax, quotation.quotation_currency)}
                                      </td>
                                    </tr>
                                  ));
                                }).flat();
                              })()
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td className="text-end" colSpan={3}>Total Before Tax</td>
                              <td className="text-end">
                                <strong>{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</strong>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Attachments</div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row align-items-baseline form-group mb-4">
                        <div className="col-md-2">
                          <label>Files <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-10">
                          {/* <input className="form-control" type="file" multiple={true} accept=".pdf, .png, .jpg, .jpeg, .gif, .webp, .svg, .bmp, .avif, .csv, .xls, .xlsx" onChange={(e) => setAttachmentFiles(Array.from(e.target.files))} required/> */}
                          <div className="table-responsive">
                            <table className="table table-bordered mb-2">
                              <thead>
                                <tr>
                                  <th className="bg-secondary text-light" style={{textAlign: 'center'}}>#</th>
                                  <th className="bg-secondary text-light w-400">Name</th>
                                  <th className="bg-secondary text-light">File</th>
                                  <th className="bg-secondary text-light"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {attachmentList && attachmentList.map((attachment, a) =>
                                  <tr key={"attachment-" + a}>
                                    <td valign="middle" align="center">{a + 1}</td>
                                    <td valign="middle">
                                      <input className="form-control" type="text" value={attachment.name} onChange={(e) => changeAttachmentData('name', e.target.value, a)} required />
                                    </td>
                                    <td valign="middle">
                                      {attachment.loading === false ? (
                                        <div>
                                          {attachment.files ? (
                                            <a className="ellipsis" href={attachment.files[0].fileUrl} target="_blank" rel="noopener noreferrer">{shortenUrl(attachment.files[0].fileUrl, 50)} <i className="bi bi-link-45deg ms-2"/></a>
                                          ) : (
                                            <input className="form-control" type="file" accept=".pdf, .png, .jpg, .jpeg, .gif, .webp, .svg, .bmp, .avif, .csv, .xls, .xlsx" onChange={(e) => uploadAttachments(Array.from(e.target.files), a)} required />
                                          )}
                                        </div>
                                      ) : 'Loading...'}
                                    </td>
                                    <td valign="middle" align="center">
                                      <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => removeAttachments(a)}><i className="bi bi-trash"/></button>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="d-flex justify-content-start">
                            <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => addAttachments()}><i className="bi bi-plus-lg me-2"/> Attachment</button>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-baseline form-group mb-2">
                        <div className="col-md-2">
                          <label>Quotation Remarks</label>
                        </div>
                        <div className="col-md-10">
                          <textarea className="form-control" rows="4" value={quotationRemarks} placeholder="Additional information for Quotation..." onChange={(e) =>setQuotationRemarks(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row align-items-baseline form-group mb-2">
                        <div className="col-md-2">
                          <label>Sales Order Remarks</label>
                        </div>
                        <div className="col-md-10">
                          <textarea className="form-control" rows="4" value={salesOrderRemarks} placeholder="Additional information for Sales Order..." onChange={(e) =>setSalesOrderRemarks(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Attainment</div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row align-items-baseline form-group mb-4">
                        <div className="col-md-2">
                          <label>SKU <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-10">
                          <div className="table-responsive">
                            <table className="table table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th className="bg-secondary text-light" style={{textAlign: 'center'}}>#</th>
                                  <th className="bg-secondary text-light">Name</th>
                                  <th className="bg-secondary text-center text-light w-80">Period</th>
                                  <th className="bg-secondary text-center text-light w-80">Qty</th>
                                  <th className="bg-secondary text-center text-light w-300">Calculations</th>
                                  {/* <th className="bg-secondary text-center text-light w-120">Price</th>
                                  <th className="bg-secondary text-center text-light w-120">Discount</th>
                                  <th className="bg-secondary text-center text-light w-125">Subtotal</th>
                                  <th className="bg-secondary text-center text-light w-125">Margin</th> */}
                                  <th className="bg-secondary text-light w-10"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {attainmentItems && attainmentItems.map((attainmentItem, a) =>
                                  <tr key={"attainment-" + a}>
                                    <td align="center">{a + 1}</td>
                                    <td>
                                      <select className="form-select" value={attainmentItem.id_quotation_item_list} onChange={(e) => changeAttainmentItem('id_quotation_item_list', e.target.value, a)} required>
                                        <option value=""></option>
                                        {quotationItemList && quotationItemList.map((quotationItem, ai) =>
                                          <option key={"item-" + ai} value={quotationItem.id_quotation_item_list}>{quotationItem.product_display_name}</option>
                                        )}
                                      </select>
                                    </td>
                                    <td>
                                      <input className="form-control text-end" type="number" min={0} max={attainmentItem.product_period_max} value={attainmentItem.product_period} onChange={(e) => changeAttainmentItem('product_period', e.target.value, a)} required />
                                      <span className="d-block w-100 text-center mt-2">Month(s)</span>
                                    </td>
                                    <td>
                                      <input className="form-control text-end" type="number" min={0} max={attainmentItem.product_qty_max} value={attainmentItem.product_qty} onChange={(e) => changeAttainmentItem('product_qty', e.target.value, a)} required />
                                      <span className="d-block w-100 text-center mt-2">Unit(s)</span>
                                    </td>
                                    {/* <td className="text-center">{priceFormat(attainmentItem.product_discount_price, 'IDR')}</td>
                                    <td className="text-center">{priceFormat(attainmentItem.product_total, 'IDR')}</td>
                                    <td className="text-center">{priceFormat(attainmentItem.product_margin_price, 'IDR')}</td> */}
                                    <td>
                                      <div className="row mb-2">
                                        <div className="col-md-6">Unit Cost</div>
                                        <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_cost, 'IDR')}</div>
                                      </div>
                                      <div className="row mb-4">
                                        <div className="col-md-6">Unit Price</div>
                                        <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_price, 'IDR')}</div>
                                      </div>
                                      {/* <div className="row mb-3">
                                        <div className="col-md-6">Unit Discount</div>
                                        <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_discount_unit, 'IDR')}</div>
                                      </div> */}
                                      <div className="row mb-2">
                                        <div className="col-md-6">Subtotal</div>
                                        <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_subtotal, 'IDR')}</div>
                                      </div>
                                      <div className="row mb-2">
                                        <div className="col-md-6">Discount</div>
                                        <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_discount_item, 'IDR')}</div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-md-6">Total</div>
                                        <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_total, 'IDR')}</div>
                                      </div>
                                      <div className="row mb-2">
                                        <div className="col-md-6">Cost</div>
                                        <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_total_cost, 'IDR')}</div>
                                      </div>
                                      <div className="row mb-2">
                                        <div className="col-md-6 strong">Margin</div>
                                        <div className="col-md-6 text-end strong">{priceFormat(attainmentItem.product_margin_price, 'IDR')}</div>
                                      </div>
                                    </td>
                                    <td align="center">
                                      <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => removeAttainmentItem(a)}><i className="bi bi-trash"/></button>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colSpan={4} className="bg-transparent p-0">
                                    <button className="btn btn-sm btn-outline-secondary mt-1" type="button" onClick={() => addAttainmentItem()}><i className="bi bi-plus-lg me-2"/> Item</button>
                                  </td>
                                  <td className="bg-transparent">
                                    <div className="row mb-2">
                                      <div className="col-md-6 strong">Amount</div>
                                      <div className="col-md-6 text-end strong">{priceFormat(attainmentItems.reduce((total, attainmentItem) => total + Number(attainmentItem.product_margin_price), 0), 'IDR')}</div>
                                    </div>
                                  </td>
                                  {/* <td colSpan="2" className="text-end strong bg-transparent">Total Profit</td>
                                  <td className="text-end strong bg-transparent">{priceFormat(attainmentItems.reduce((total, attainmentItem) => total + Number(attainmentItem.product_margin_price), 0), 'IDR')}</td> */}
                                  <td className="bg-transparent"></td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-baseline form-group mb-2">
                        <div className="col-md-2">
                          <label>Quarter <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-3">
                          <select className="form-select" value={attainmentQuarter} onChange={(e) => setAttainmentQuarter(e.target.value)} required>
                            <option value="1">{`Q1 ${format(new Date(), 'yyyy')}`}</option>
                            <option value="2">{`Q2 ${format(new Date(), 'yyyy')}`}</option>
                            <option value="3">{`Q3 ${format(new Date(), 'yyyy')}`}</option>
                            <option value="4">{`Q4 ${format(new Date(), 'yyyy')}`}</option>
                          </select>
                        </div>
                      </div>
                      <div className="row align-items-baseline form-group mb-2">
                        <div className="col-md-2">
                          <label>Remarks</label>
                        </div>
                        <div className="col-md-10">
                          <textarea className="form-control" rows="4" value={attainmentRemarks} placeholder="Additional information for Attainment..." onChange={(e) =>setAttainmentRemarks(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="d-flex justify-content-end">
                    <button className="btn btn-link" type="button" onClick={() => window.location.href = '/quotation/detail/' + id_quotation} disabled={isLoadingSubmit}>Cancel</button>
                    <button className="btn btn-primary ms-2" type="button" onClick={() => submitSalesOrderAdd()} disabled={isLoadingSubmit || (attachmentList && attachmentList.some((attachment) => attachment.loading === true))}>{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesOrderAdd;


